// extracted by mini-css-extract-plugin
module.exports = {"container":"AudioPlayer_container__36puz","title":"AudioPlayer_title__1uWX6","description":"AudioPlayer_description__g8sbH"};